export enum FeedItemVoteType {
  Approve = 'Approve',
  Disapprove = 'Disapprove',
}
